import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { SectionWrapperComponent } from '../section-wrapper/section-wrapper.component';
import { SiteConfigService } from '../../services/site-config.service';

@Component({
  selector: 'app-pricing',
  imports: [SectionWrapperComponent, MatIconModule],
  templateUrl: './pricing.component.html',
  styleUrl: './pricing.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PricingComponent {
  private readonly siteConfig = inject(SiteConfigService);

  readonly section = this.siteConfig.pricing;
}
